// eslint-disable-next-line import/prefer-default-export
export const OL_COUNTER_NAME = 'allium-ordered-list-counter';